<template lang="pug">
  div.skip
    div.skip-header
      img(src="/img/success.svg")
      h1 Благодарим за пользование<br>услугами АО «СТАТУС»!
    Box
      p Номер вашего заказа № {{ orderNumber }}
      p Ожидаем вас {{ visitDate }} в {{ visitTime }}
      p на подачу документов в офисе АО «СТАТУС»
      p по адресу:&nbsp;
        a(:href="mapLink" class="map__link" target="_blank") {{ address }}
      p Не забудьте взять с собой паспорт
      .form__button
        Button(
          :action="toMain"
          :classes="['is-large']"
          label="Понятно"
        )
</template>

<script>
import Box from "@/components/ui/Box";
import Button from "@/components/Button";
import { dateToHuman } from "@/plugins/date-utils";
import { mapLink } from "@/plugins/ymap-utils";

export default {
  components: {
    Box,
    Button
  },
  data() {
    return {
      orderNumber: "",
      visitDate: "",
      visitTime: "",
      address: "",
      mapLink: ""
    };
  },
  created() {
    let paymentData = sessionStorage.getItem("payment_data");
    if (paymentData) {
      paymentData = JSON.parse(paymentData);

      this.orderNumber = paymentData.order_number;
      this.visitDate = dateToHuman(paymentData.visit_date);
      this.visitDate = paymentData.visit_time;
      this.address = paymentData.address;
      this.mapLink = mapLink(paymentData.coordinates);

      sessionStorage.removeItem("payment_data");
    } else {
      this.toMain();
    }
  },
  methods: {
    toMain() {
      window.location.href = process.env.VUE_APP_MAIN_PAGE;
    }
  }
};
</script>

<style lang="scss">
a {
  color: #3b7bbe;
  outline: 0;
  text-decoration: none;

  &:hover {
    color: #3b7bbe;
  }
}

.skip {
  &-header {
    img {
      margin: 0 auto;
      padding-bottom: 15px;
    }
    h1 {
      color: #fff;
      text-align: center;
      padding-bottom: 30px;
    }
  }

  .box {
    display: block;
    min-height: auto;

    p {
      font-size: 22px;
      line-height: 33px;
      color: #333;
      text-align: center;

      &.bold {
        font-weight: 700;
      }
    }

    .form__button {
      padding-top: 30px;

      button {
        margin: 0 auto;
      }
    }
  }
}
</style>
